import {
    section,
    container,
    cardTitle,
    coloredShadow,
    mlAuto,
    mrAuto,
    description,
    successColor,
    dashed
} from "../../../material-kit-pro-react.jsx";

import customCheckboxRadioSwitch from "../../../material-kit-pro-react/customCheckboxRadioSwitchStyle.jsx";

import tooltipsStyle from "../../../material-kit-pro-react/tooltipsStyle.jsx";

const styles = {
    ...customCheckboxRadioSwitch,
    ...tooltipsStyle,
    coloredShadow,
    mlAuto,
    mrAuto,
    // cardTitle: {
    //     ...cardTitle,
    //     textAlign: "center",
    //     marginBottom: "0px !important",
    //     minHeight: "54px",
    //     height: "54px"
    // },
    cardTitle,
    cardDescription: {
        color: "#999",
        textAlign: "center"
    },
    container: {
        ...container
    },
    description: {
        color: "#999"
    },
    section: {
        ...section,
        padding: "70px 0px"
    },
    priceContainer: {
        display: "inline-flex"
    },
    price: {
        fontSize: "19px",
        color: "#3C4858", // "#9a9a9a" dancard
        fontWeight:"500"
    },
    pullRight: {
        float: "right"
    },
    cardHeaderImage: {
        position: "relative",
        padding: "0",
        zIndex: "1",
        marginLeft: "15px",
        marginRight: "15px",
        marginTop: "-30px",
        borderRadius: "6px",
        "& img": {
            width: "100%",
            borderRadius: "6px",
            pointerEvents: "none"
        },
        "& a": {
            display: "block"
        }
    },
    justifyContentBetween: {
        WebkitBoxPack: "justify!important",
        justifyContent: "space-between !important"
    },
    customExpandPanel: {
        maxHeight: "273px",
        overflowY: "scroll",
        "&  label": {
            display: "block"
        }
    },
    priceSlider: {
        fontWeight: "500"
    },
    refineButton: {
        margin: "-3px 0"
    },
    cardBodyRefine: {
        paddingLeft: "15px",
        paddingRight: "15px"
    },
    textLeft: {
        textAlign: "left"
    },
    centerImg: {
        height: "145px",
        minHeight: "145px",
        padding: "auto"
    },
    truncatedText: {
        minHeight: "80px",
        height: "80px"
    },
    errorDisplay: {
        color: "red"
    },
    compressedInput: {
        margin: "0",
        paddingTop: "0"
    },
    compressedInput2: {
        margin: "0",
        paddingTop: "3px"
    },
    compressedInput3: {
        margin: "0",
        paddingTop: "6px"
    },





    cardCatalog: {
        marginTop: "10px",
        marginBottom: "10px"
    },
    vecCardHeader: {
        margin: "0",
        padding: "0"
    },
    vecCenterImg: {
        height: "175px",
        width: "100%",
        padding: "auto"
    },
    vecGridItemImg : {
        padding: "0"
    },
    vecCardFooter: {
        display: "block",
        position: "absolute",
        top: "30px",
        right: "8px",
        textAlign: "right"
    },
    vecPriceTextContainer: {
        marginTop: "-5px",
        marginBottom: "-5px"
    },



    dashed,
    card: {
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardCategory: {
        marginBottom: "0",
        marginTop: "7px",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            position: "relative",
            top: "8px",
            lineHeight: "0"
        }
    },
    description1: {
        ...description,
        lineHeight: "1.313rem"
    },
    author: {
        "& a": {
            color: "#3C4858",
            textDecoration: "none"
        }
    },
    vecPriceContainer: {
        "@media (max-width: 700px)": { // Show in mobile
            position: "relative"
        },
        "@media (min-width: 700px)": { // Show in desktop
            position: "absolute",
            textAlign: "right",
            bottom: "5px",
            right: "5px"
        }
    },
    vecPriceNumber: {
        marginTop: "-5px",
        marginBottom: "-5px",
        fontWeight: "500"
    },
    vecImgContainer: {
        padding: "0"
    },
    vecImg: {
        height: "210px"
    },
    vecAdvice: {
        color: "red"
    },
    cardPricing: {
        boxShadow: "none"
    },
    cardIcons: {
        top: "6px",
        position: "relative"
    },
    successColor: {
        color: successColor
    },
    vecCardActivities: {
        display: "inline-block",
        position: "relative",
        margin: "0",
        border: "0px",
        color: "rgba(0,0,0,0.87)",
        width: "100%",
        "& ul": {
            listStyle: "none",
            padding: "0 9px",
            margin: "0"
        },
        "& ul li": {
            padding: "0",
            margin: "-10px",
            textAlign: "left"
        },
        "& ul li b": {
            minWidth: "24px",
            display: "inline-block",
            textAlign: "center"
        }
    },
    vecUlLeft: {
        marginInlineStart: "-38px",
        marginTop: "3px"
    },
    selectFormControl: {
        margin: "10px 1px 10px 0px !important",
        "& > div": {
            "&:before": {
                borderBottomWidth: "1px !important",
                borderBottomColor: "#D2D2D2 !important"
            },
            "&:after": {
                borderBottomColor: successColor + "!important"
            }
        }
    },
    advertisementTextDanger: {
        marginBottom: "0",
        marginTop: "7px",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            position: "relative",
            top: "8px",
            lineHeight: "0"
        },
        color: 'red'
    },
    advertisementTextSuccess: {
        marginBottom: "0",
        marginTop: "7px",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            position: "relative",
            top: "8px",
            lineHeight: "0"
        },
        color: 'green'
    }
};

export default styles;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.jsx